const routes = [
    {
        path: "/change-information-form",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
        },
    },
];

export default routes;
